export default __webpack_public_path__ + "static/media/quoridor.8f998e38.png";